import styled from 'styled-components';

import Box from 'relements/build/esm/ui/box';
import Button from 'relements/build/esm/ui/button';
import Icon from 'relements/build/esm/ui/icon';

const ContainerStyle = (props) => ({
  flexDirection: 'column',
  padding: props.theme.space.zero,
  marginTop: '30px',
});
export const Container = styled(Box)(ContainerStyle);

const RowStyle = (props) => ({
  padding: '20px',
  width: '578px',
  background: props.theme.colors.background,
});
export const Row = styled(Box)(RowStyle);

const ContentBoxStyle = (props) => ({
  height: '42px',
  alignItems: 'center',
  padding: props.theme.space.zero,
  marginTop: props.theme.space.xs,
});
export const ContentBox = styled(Box)(ContentBoxStyle);

const ColumnStyle = (props) => ({
  flexDirection: 'column',
  justifyContent: 'center',
  padding: props.theme.space.zero,
});
export const Column = styled(Box)(ColumnStyle);

const IconButtonStyle = () => ({
  display: 'flex',
  alignItems: 'center',
});
export const IconButton = styled(Button)(IconButtonStyle);

const IconStyle = (props) => ({
  height: `${props.height} !important`,
  width: `${props.width} !important`,
  marginRight: props.theme.space.xs,
});
export const SvgIcon = styled(Icon)(IconStyle);

const LinkBoxStyle = (props) => ({
  padding: props.theme.space.md,
  paddingRight: '22px',
  background: props.theme.colors.yellow.pastel,
  marginTop: '15px',
  width: 'fit-content',
  boxSizing: 'border-box',
});
export const LinkBox = styled(Box)(LinkBoxStyle);

const LinkStyle = (props) => ({
  borderBottom: `1px solid ${props.theme.colors.yellow.haptik}`,
  textDecoration: 'none',
});
export const Link = styled('a')(LinkStyle);
